import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { Subject, Subscription } from 'rxjs';
import { FileUploaderModel } from './file-uploader-model';
import { FileUpload } from 'primeng/primeng';
//import { ConfigurationService } from '../../admin/configuration/configuration.service';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.css']
})
export class FileUploaderComponent implements OnInit {

  @ViewChild('fileUpload') fileUpload: FileUpload;
  @Input() onUploadClicked: Subject<any>;

  @Input() data: any;
  @Input() dataContext: FileUploaderModel = new FileUploaderModel();
  @Input() downloadLink: any;
  @Output() public onFilesModification: EventEmitter<any> = new EventEmitter();
  @Output() public onFilesSelect: EventEmitter<any> = new EventEmitter();
  @Output() public onFilesRemove: EventEmitter<any> = new EventEmitter();
  @Output() public onFilesDownload: EventEmitter<any> = new EventEmitter();
  FileURL: any;
  private uploadSubscription: Subscription;
  constructor() { }

  ngOnInit() {
    this.dataContext.Parameter = this.data;
    if (!this.uploadSubscription) {
      this.uploadSubscription = this.onUploadClicked.subscribe(event => {
        this.customUploader(this.fileUpload.files, this.fileUpload);
      });
    }
  }

  ngOnChanges(changes: any) {
    if (changes.data != null && changes.data.currentValue != null) {
      this.dataContext.Parameter = this.data;
    }
  }

  ngOnDestroy() {
    if (!!this.uploadSubscription) {
      this.uploadSubscription.unsubscribe();
    }
  }

  customUploader($event: any, fileUpload: any) {
    if ($event.length === 0 || $event.length > this.dataContext.fileUploaderSettings.fileLimit) {
      return;
    }
    let formData = new FormData();

    //if ($event && $event[0]) {
    //    var reader = new FileReader();

    //    reader.readAsDataURL($event[0]); // read file as data url

    //    reader.onload = (event) => { // called once readAsDataURL is completed
    //        this.FileURL = reader.result;
    //    }
    //}

    for (const file of $event) {
      formData.append("files", file);
    }

    fileUpload.clear();

    if(this.dataContext.fileUploaderSettings.fileLimit === 1)
      this.onFilesModification.emit($event.files[0]);
    else
      this.onFilesModification.emit($event.files);
  }

  removeErrorMessage() {
    this.dataContext.errorMessage = null;
    //this.dataContext.Parameter = this.dataContext;
  }

  removeAttachmentFile(index: any) {
    //this.onFilesRemove.emit(index);
  }

  downloadAttachmentFile(file: any) {
    this.onFilesDownload.emit(file);
  }

  selectedFile($event: any) {
    this.onFilesSelect.emit($event);
  }

  uploadFile($event: any) {
    //this.onFilesModification.emit(this.dataContext);
  }

  removeFile(index: any) {
    this.onFilesRemove.emit(index);
    //this.onFilesModification.emit(this.dataContext);
  }

  downloadTemplate() {
    window.open(this.downloadLink);
  }
}
